import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { EntityFormMode } from '@/common/entityFramework/enumerations/EntityFormMode';
import { useForm } from '@/common/form/FormContext';
import { DateFormField } from '@/common/form/formFields/DateFormField';
import { DateUtils } from '@/common/utils/DateUtils';
import { useEffect, useMemo } from 'react';

export const ProdPriceDate = ({ priceTypeIdToPeriodicity, fieldDef }) => {
  const { formValues, assignValue } = useForm();
  const { entityFormMode } = useEntityMgr();

  const periodicity = formValues.priceTypeId != null ? priceTypeIdToPeriodicity[formValues.priceTypeId] : undefined;

  useEffect(() => {
    if (!formValues.periodCode) return;
    const date =
      fieldDef.field === 'startDate' ?
        DateUtils.periodStartDate(formValues.periodCode)
      : DateUtils.periodEndDate(formValues.periodCode);
    assignValue(fieldDef.field, date);
  }, [formValues.periodCode]);

  const updatedFieldDef = useMemo(() => {
    assignValue(fieldDef.field, null);
    return {
      ...fieldDef,
      disabled: periodicity != null || entityFormMode !== EntityFormMode.ADD,
      required: periodicity == null,
    };
  }, [periodicity]);

  return <DateFormField fieldDef={updatedFieldDef} />;
};
